export default __webpack_public_path__ + "static/media/placeholder_dummy2016-wellness01-de.8a548178.png";